import { render } from "./Battery.vue?vue&type=template&id=0de64b35"
import script from "./Battery.vue?vue&type=script&lang=js"
export * from "./Battery.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\car-status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__